import React from "react";

import Link from "next/link";

import { EditOutlined } from "@ant-design/icons";
import { t, Trans } from "@lingui/macro";
import { Col, Divider, Row, Tag, Typography } from "antd";
import styled from "styled-components";

import { FuelCard as FuelCardType } from "types";

import { formatDate } from "utils/datetime-utils";

const Container = styled(Row)`
  background: ${(props) => props.theme.colorBgContainer};
  padding: ${(props) => props.theme.paddingSM}px;
  width: 100%;
  border-radius: ${(props) => props.theme.borderRadius}px;
  border: 1px solid ${(props) => props.theme.colorSplit};
`;

const FuelCard = ({ data }: { data: FuelCardType }) => {
  return (
    <Container>
      <Col span={24}>
        <Row justify={"space-between"} align={"middle"}>
          <Tag color={data.active ? "green" : undefined}>{data.active ? t`Active` : t`Inactive`}</Tag>
          <Link href={`/settings/fuel-cards/${data?.id}/`}>
            <EditOutlined />
          </Link>
        </Row>
      </Col>
      <Col span={24}>
        <Typography.Title level={4}>{data.number}</Typography.Title>
      </Col>
      <Divider />
      <Col span={24}>
        <Row gutter={[8, 8]}>
          <Col span={8}>
            <Typography.Text strong>
              <Trans>Vehicle</Trans>
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Typography.Text>{data.vehicle || "-"}</Typography.Text>
          </Col>
          <Col span={8}>
            <Typography.Text strong>
              <Trans>Driver</Trans>
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Typography.Text>{data.driver || "-"}</Typography.Text>
          </Col>
          <Col span={8}>
            <Typography.Text strong>
              <Trans>PIN</Trans>
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Typography.Text>{data.pin || "-"}</Typography.Text>
          </Col>
          <Col span={8}>
            <Typography.Text strong>
              <Trans>Expires on</Trans>
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Typography.Text>{formatDate(data?.expiration_date) || "-"}</Typography.Text>
          </Col>
          <Col span={8}>
            <Typography.Text strong>
              <Trans>Retail chain</Trans>
            </Typography.Text>
          </Col>
          <Col span={16}>
            <Typography.Text>{data?.fuel_station_chain || "-"}</Typography.Text>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default FuelCard;
